import React from 'react';
import { Award, Users, Code, Zap } from 'lucide-react';
import { personalInfo as mockInfo, education, certifications } from '@/mock';
import '../styles/AboutSection.css';

const AboutSection = ({ settings, loading }) => {
  // Use settings from API or fallback to mock
  const info = settings || mockInfo;

  return (
    <section className="about-section" id="about">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">About Me</h2>
          <div className="title-underline"></div>
        </div>

        <div className="about-content">
          <div className="about-image-container">
            <div className="about-image-wrapper">
              <img 
                src={info.aboutImage || mockInfo.aboutImage} 
                alt={info.name} 
                className="about-image" 
              />
              <div className="image-overlay"></div>
            </div>
          </div>

          <div className="about-text">
            <div className="about-intro">
              <h3 className="about-subtitle">{info.title || 'Senior Mobile Engineer'}</h3>
              <p className="about-description">{info.bio}</p>
            </div>

            <div className="about-highlights">
              <div className="highlight-item">
                <div className="highlight-icon">
                  <Code size={24} />
                </div>
                <div className="highlight-content">
                  <h4>Technical Excellence</h4>
                  <p>Expert in Flutter, iOS, and mobile architecture patterns</p>
                </div>
              </div>

              <div className="highlight-item">
                <div className="highlight-icon">
                  <Users size={24} />
                </div>
                <div className="highlight-content">
                  <h4>Team Leadership</h4>
                  <p>Led teams of 10+ developers in agile environments</p>
                </div>
              </div>

              <div className="highlight-item">
                <div className="highlight-icon">
                  <Zap size={24} />
                </div>
                <div className="highlight-content">
                  <h4>Performance Focus</h4>
                  <p>Optimized apps serving millions with exceptional stability</p>
                </div>
              </div>

              <div className="highlight-item">
                <div className="highlight-icon">
                  <Award size={24} />
                </div>
                <div className="highlight-content">
                  <h4>CSPO Certified</h4>
                  <p>Certified Scrum Product Owner with agile expertise</p>
                </div>
              </div>
            </div>

            <div className="education-cert-grid">
              <div className="education-card">
                <h4 className="card-title">Education</h4>
                {education.map((edu) => (
                  <div key={edu.id} className="education-item">
                    <div className="edu-degree">{edu.degree}</div>
                    <div className="edu-institution">{edu.institution}</div>
                    <div className="edu-details">
                      <span>{edu.duration}</span>
                      <span className="edu-gpa">GPA: {edu.gpa}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="certifications-card">
                <h4 className="card-title">Certifications</h4>
                <div className="cert-list">
                  {certifications.map((cert) => (
                    <div key={cert.id} className="cert-item">
                      <div className="cert-badge">
                        <Award size={16} />
                      </div>
                      <div className="cert-info">
                        <div className="cert-name">{cert.name}</div>
                        <div className="cert-issuer">{cert.issuer} • {cert.year}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;